:host {
  @apply block w-full h-full;
}

.swiper-slide {
  @apply block relative w-full h-auto box-border flex-none;
}

figcaption {
  @apply text-grey-light text-sm mb-0 pt-[5px];
}

@media only screen and (min-width: 1921px) {
  .swiper-slide-active {
    opacity: 1 !important;
    z-index: 1 !important;
  } 
}